module.exports = __webpack_public_path__ + "img/map.59311b14.svg";